import { render, staticRenderFns } from "./NutritionToolView.vue?vue&type=template&id=41620fdd&scoped=true"
import script from "./NutritionToolView.vue?vue&type=script&lang=js"
export * from "./NutritionToolView.vue?vue&type=script&lang=js"
import style0 from "./NutritionToolView.vue?vue&type=style&index=0&id=41620fdd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41620fdd",
  null
  
)

export default component.exports